
Vue.component("question_answer_item", {
  props: {
      data: {
          type: Object,
          required: true,
          default: () => ({})
      },
      user_info: {
          type: Object,
          required: true,
          default: () => ({})
      },
      teachers_code: {
        type: Array,
        required: true,
        default: () => []
      },
      course_id: {
        type: String,
        required: true,
        default: ""
      },
  },
  computed: {
    canDelete() {
      return this.user_info.user_code == this.data.user_id || this.user_info.roles?.includes('r_sys_manager') || this.user_info.roles?.includes('r_course_manager') || this.teachers_code.includes(this.user_info.user_code)
    },
    canOpen() {
      return (this.user_info.roles?.includes('r_sys_manager') || this.user_info.roles?.includes('r_course_manager') || this.teachers_code.includes(this.user_info.user_code)) && window.location.pathname.includes('mooc')
    }
  },
  data(){
    this.global = window
    return{

    }
  },
  methods: {
      deleteHandle() {
          API.deleteQuestion({topic_id_list: [this.data.topic_id]}).then(res => {
              if (res.error_msg === "Success") {
                  this.$message.success(this.$t("删除成功"))
                  this.$emit("delete", this.data)
              } else {
                  this.$message.error(this.$t("删除失败"))
              }
          })
      },
      clickHandle() {
          if (this.data.unread_id != null) {
              API.updateRead({ids: this.data.unread_id})
          }
          this.$emit("toDetail", this.data)
      },
      handlePublic(isPublic, isEdit) {
        if (isPublic) {
          this.$emit("showPublicModal", isEdit)
        } else {
          API.updateQaStatus({ link_id: this.course_id, topic_id: this.data.topic_id, permissions: "0" }).then(res => {
            if (res.error_msg === "Success") {
              this.$emit("onPublicChange", this.data.topic_id, false)
              this.$message.success(this.$t("取消公开成功！"));
            } else {
              this.$message.error(this.$t("取消公开失败！"));
            }
          });
        }
      },
  },
  template: `
  <div class="question_answer_item">
    <div class="top-container" @click="clickHandle">
      <div class="header-container">
        <el-tooltip class="item" effect="dark" :content="$t('此被老师选为公开问答')" placement="top">
          <span class="permission_icon" v-if="global.location.pathname.includes('mooc') && data.permissions != '0'">{{$t('公开')}}</span>
        </el-tooltip>
        <span class="header-text">{{data.title}}</span>
        <span class="message-container" v-if="data.unread_subtotal">
          <span>{{data.unread_subtotal}}{{$t('条新回复')}}</span>
        </span>
        <span v-if="data.unread_id != null" class="new-tag">new</span>
      </div>
      <div class="footer-container">
        <span class="stu-name">{{data.user_name}}</span>
        <div class="col-line"></div>
        <span>{{dateFormate(Number(data.created + '000'), "y.m.d h:i")}}{{$t('提问')}}</span>
      </div>
      <div class="content">{{data.content}}</div>
      <div class="footer-container">
        <el-button
          v-if="canDelete"
          size="mini"
          type="text"
          @click="clickHandle"
        ><iconfont type="iconkuaisuhuifu"></iconfont>{{$t('回复')}}</el-button>
        <template v-if="canOpen">
          <template v-if="data.permissions && data.permissions != '0'">
            <el-button
              type="text"
              size="mini" icon="el-icon-unlock"
              @click.stop="handlePublic(true, true)"
            >{{$t('修改公开类型')}}</el-button>
            <el-button
              type="text"
              size="mini" icon="el-icon-lock"
              @click.stop="handlePublic(false)"
            >{{$t('取消公开')}}</el-button>
          </template>
          <el-button
            v-else
            type="text"
            size="mini" icon="el-icon-unlock"
            @click.stop="handlePublic(true)"
          >{{$t('设为公开')}}</el-button>
        </template>
        <el-popconfirm
          :title="$t('确定删除当前问答吗？')"
          @confirm="deleteHandle"
        >
          <el-button
            v-if="canDelete"
            type="text"
            size="mini"
            slot="reference"
            @click.stop="() => null"
          ><iconfont type="icondelete1"></iconfont>{{$t('删除')}}</el-button>
        </el-popconfirm>
      </div>
    </div>
  </div>
`
});